import { render, staticRenderFns } from "./ReviewContractDetails.vue?vue&type=template&id=cb909722&scoped=true"
import script from "./ReviewContractDetails.vue?vue&type=script&lang=js"
export * from "./ReviewContractDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewContractDetails.vue?vue&type=style&index=0&id=cb909722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb909722",
  null
  
)

export default component.exports